export const SOME_ACTION = 'SOME_ACTION';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const PRESENTATION_MODE ='PRESENTATION_MODE';
export const NIGHT_MODE = 'NIGHT_MODE';
export const UPDATE_ACTIVE_URI = 'UPDATE_ACTIVE_URI';
export const UPDATE_ACTIVE_MENU = 'UPDATE_ACTIVE_MENU';
export const UPDATE_ACTIVE_SUBMENU = 'UPDATE_ACTIVE_SUBMENU';
export const GETCLIENTLIST = 'GETCLIENTLIST';
export const GET_FULL_SCOPE = 'GET_FULL_SCOPE';
export const SORT_HEADER = 'SORT_HEADER';
export const SORT_HEADER_BY_COLUMN_ID='SORT_HEADER_BY_COLUMN_ID';
export const UPDATE_ACTIVE_DATA = 'UPDATE_ACTIVE_DATA';
export const UPDATE_CLIENT_ACTIVE = 'UPDATE_CLIENT_ACTIVE'; 
export const CHANGE_FULL_LOADING = 'CHANGE_FULL_LOADING';

// API 
export const OPEN_SESSION_RETURN = 'OPEN_SESSION_RETURN';
export const LOGIN_RETURN = 'LOGIN_RETURN';
export const LOGOUT = 'LOGOUT';
export const CLIENT_LISTING = 'CLIENT_LISTING';
export const EXTRACT_USERNAME ='EXTRACT_USERNAME';
export const PER_LOAD_RETURN = 'PER_LOAD_RETURN';
export const CREATE_MENU = 'CREATE_MENU';
export const EXTRACT_FIDUCIAIRE = 'EXTRACT_FIDUCIAIRE';
export const ON_FORMATING_DATA ='ON_FORMATING_DATA';